<div
  *ngIf="insightsTags && isDebugMode"
  class="insights-tags__label--show-card"
>
  <label>Asset Class:</label>
  <span *ngFor="let assetclass of insightsTags?.assetclassPage">
    {{ assetclass }},</span
  ><br /><br />
  <label>Investment Team:</label>
  <span *ngFor="let investdet of insightsTags?.investmentteam">
    {{ investdet }},</span
  ><br /><br />
  <label>Investment Theme:</label>
  <span *ngFor="let investtheme of insightsTags?.investmenttheme">
    {{ investtheme }},</span
  ><br /><br />
  <label>Publication Series:</label>
  <span *ngFor="let publication of insightsTags?.publicationseries">
    {{ publication }},</span
  ><br /><br />
  <label>Speciality:</label>
  <span *ngFor="let inspecial of insightsTags?.speciality">
    {{ inspecial }},</span
  ><br /><br />
</div>
